define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/xml",
	"./_MaterialFormMixin",
	"./ProductType"
], function(declare, locale, xml, _MaterialFormMixin, ProductType) {

	return declare(_MaterialFormMixin, {

		// String: last know material type
		_lastType: null,

		_requiredExpressions: {
			DimensionType: "attr('__ProductSize') != ''"
		},

		_resolveView: function() {
			// make color and size as text input fields since the material does not exist
			var colorField = this.defView.getField("ProductColor");
			var sizeField = this.defView.getField("ProductSize");

			if (colorField) {
				colorField.m_id = null;
				colorField.m_label = "ProductColor";
			}

			if (sizeField) {
				sizeField.m_id = null;
				sizeField.m_label = "ProductSize";
			}

			this.inherited(arguments);

			// unset the required flag on DimensionType
			const dimField = this.getField("DimensionType");
			if (dimField) {
				dimField.m_bRequired = false;
			}

			// SampleStorage is a reverse relationship of a refmap without an aggregate store, so we cannot properly add the sample to the map; skip for now
			// this can be removed after implementing C8-55914
			const sampleStorageField = this.getField("SampleStorage");
			if (sampleStorageField) {
				sampleStorageField.omitFromReport = true;
			}
		},

		_buildView: function() {
			// summary: initialize supplier field when creating sample from material
			var fd = this.defView.m_formData;
			var parent = fd.getParent();
			if (parent && parent.ProductSourcing) {
				var materialSourcing = fd.getCache().getNode(parent.ProductSourcing, true);
				var materialQuote = fd.getCache().addNode(materialSourcing.DefaultQuote);
				if (materialQuote) {
					var materialSource = fd.getCache().getNode(materialQuote.__Parent__, true);
					this.addDefaultValue("Supplier", materialSource.Supplier);
				}
			}

			// no simple way to resolve path from MaterialSample to Material correctly, so hard-code name here
			this.defView.getField(this.PRODUCT_TYPE).m_label = locale.typeId("Material", this.PRODUCT_TYPE);
			if (parent && parent.$Type == this.MATERIAL_SECURITY_GROUP) {
				this.addFixedValue(this.MATERIAL_SECURITY_GROUPS, [parent.$URL]);
			}
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Attach form node to parent product
		 */
		onWriteFormReport(field, writer, formInfo) {
			const {nodeUrl, parentUrl, contextUrl} = formInfo;

			// if creating Sample directly under ProductSource, then nothing else to do
			if (parentUrl) {
				return;
			}
			const materialUrl = xml.getClientNodeUrl();
			const productSourceUrl = xml.getClientNodeUrl();
			const productSizeUrl = xml.getClientNodeUrl();
			const colorMaterialUrl = xml.getClientNodeUrl();

			writer.createNode(materialUrl, "Material")
				.changeAttribute("Hidden", xml.ATTR_BOOLEAN, true);

			writer.createNode(productSourceUrl, "ProductSource")
				.attach(xml.getUrlPath(materialUrl, "Child:ProductSourcing"), "ProductSources")
				.changeAttribute("Samples", xml.ATTR_REFLIST, [nodeUrl]);

			writer.createNode(productSizeUrl, "ProductSize")
				.attach(materialUrl, "ProductSizes")
				.attach(nodeUrl, "ProductSize");

			writer.createNode(colorMaterialUrl, "ColorMaterial")
				.attach(materialUrl, "ProductColors")
				.attach(nodeUrl, "ProductColor");

			writer.changeNode(materialUrl)
				.publishAttribute("ContextNode", xml.ATTR_REF, contextUrl);
		},

		_redraw: function() {
			// summary: reset type before resetting form
			this._lastType = null;
			this.inherited(arguments);
		},

		_updateFieldVisibility: function(/*Field?*/field) {
			// summary: set display of color/size fields based on material type
			var urlType = this.defView.getFieldValue(this.PRODUCT_TYPE);
			var bChange = (urlType != this._lastType);
			if (bChange) {
				var config = ProductType.getByUrl(urlType);
				var pc = this.defView.getField("ProductColor");
				var ps = this.defView.getField("ProductSize");
				var dt = this.defView.getField("DimensionType");

				this._lastType = urlType;
				this.setFieldHidden("ColorSpecification", !config || !config.HasColor);
				this.setFieldHidden(pc, !config || !config.HasColor);
				this.setFieldHidden(ps, !config || !config.HasSize);
				this.setFieldHidden(dt, !config || !config.HasSize);
			}

			return this.inherited(arguments) || bChange;
		},

		onChangeColorSpecification: function(/*csi.def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: initialize color name based on selection if color name not already set
			var pc = this.defView.getField("ProductColor") || this.defView.getField(xml.ATTR_NAME, "Child:ProductColor");
			var store = field.m_control.store;
			var color = store.get(value);

			if (pc && pc.isDefaultValue() && color) {
				this.setFieldValue(pc, color[store.labelProperty], true);
			}
		}
	});
});